import { z } from "zod";
import { IsoDateTime,Uuid } from "@secretaa/http-contract";
import { Ref,Scope } from "../work-os/primitives.ts";
/** Verified user identity only. The host supplies it; public draft bodies contain none of these fields. */
export const SurfacePrincipal=z.object({workspaceId:Uuid,subjectId:Uuid,loginSessionId:Uuid,authEpoch:z.number().int().nonnegative(),
 scopeVersion:z.number().int().nonnegative(),expiresAt:IsoDateTime}).strict();
/** Canonical access owner response; UI permissions do not authorize business data reads/actions. */
export const SurfaceAccessSnapshot=z.object({principal:SurfacePrincipal,scope:Scope,policyRef:Ref,
 canRead:z.boolean(),canEdit:z.boolean(),canPublish:z.boolean(),checkedAt:IsoDateTime,expiresAt:IsoDateTime}).strict();
export type SurfacePrincipal=z.infer<typeof SurfacePrincipal>;
export type SurfaceAccessSnapshot=z.infer<typeof SurfaceAccessSnapshot>;
